export default __webpack_public_path__ + "static/media/back.056909a7.jpg";